export default __webpack_public_path__ + "static/media/definix-full.deaa390b.svg";